var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('h4',{staticClass:"text-center header"},[_vm._v("VUFindAny-#Frame")]),_c('SearchBar',{on:{"send":_vm.getData}}),_c('ImageList',{attrs:{"img":_vm.img,"count":_vm.count}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }